/**
 * Input Text Reusable Components
 */
import React from "react";

const InputText = ({
        id,
        name, 
        value, 
        label='', 
        tagClass='',
        labelClass='',
        placeholder = '', 
        onChange,
        onFocus,
        onKeyDown,
        type = 'text',
        readOnly = false,
        autoFocus = false,
        disabled=false
    }) => {

    return (
        <>
            {label && <label htmlFor={id} className={labelClass}>{label}</label>}
            <input
                id={id}
                value={value ?? ''}
                onKeyUp={onFocus}
                onChange={(e) => onChange(e)}
                className={tagClass}
                type={type}
                name={name}
                placeholder={placeholder}
                readOnly={readOnly}
                autoFocus={autoFocus}
                onKeyDown={onKeyDown}
                disabled={disabled}
            />
        </>
    );
};

export default InputText;
